(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reparablo-easy-start"] && !Shopify.designMode) return;
  try {
    
(() => {
  const STORAGE_KEY = 'reparablo.order-form-popup.v1';
  const controllers = new Map();
  let memoryPreference = null;

  // The user's frequency preference contains no contact or device data.
  function readPreference() {
    let newest = memoryPreference;
    for (const name of ['localStorage', 'sessionStorage']) {
      try {
        const value = JSON.parse(window[name].getItem(STORAGE_KEY) || 'null');
        if (value?.daily === true && typeof value.lastDay === 'string' &&
            Number.isFinite(value.updatedAt) && (!newest || value.updatedAt >= newest.updatedAt)) newest = value;
      } catch (_) { /* Storage may be disabled; keep the usable fallback. */ }
    }
    return newest;
  }

  function rememberDaily(day) {
    const preference = { daily: true, lastDay: day, updatedAt: Date.now() };
    memoryPreference = preference;
    for (const name of ['localStorage', 'sessionStorage']) {
      try { window[name].setItem(STORAGE_KEY, JSON.stringify(preference)); } catch (_) { /* In-memory fallback. */ }
    }
  }

  function today() {
    try {
      const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const part = (type) => parts.find((entry) => entry.type === type).value;
      return `${part('year')}-${part('month')}-${part('day')}`;
    } catch (_) {
      const date = new Date();
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }
  }

  function overlayIsOpen() {
    return [...document.querySelectorAll('dialog[open], [aria-modal="true"]:not([aria-hidden="true"]), #shopify-pc__banner')].some((element) =>
      !element.hidden && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden'
    );
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-rpb-home-popup]').forEach((popup) => {
      const id = popup.dataset.sectionId;
      if (controllers.has(id)) return;
      const editor = popup.dataset.editor === 'true';
      const subscriptions = new AbortController();
      const options = { signal: subscriptions.signal };
      let timer = null;
      let frame = null;
      let pending = false;
      let focusBeforeOpening = null;
      let paused = false;

      // Keep the small floating panel out of the sticky header's stacking context.
      // The original section remains empty, so the old full-width bar is gone.
      document.body.appendChild(popup);

      function position() {
        frame = null;
        if (popup.hidden) return;
        const header = document.querySelector('#header-group');
        const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const top = Math.max(12, Math.min(headerBottom + 12, viewportHeight - popup.offsetHeight - 12));
        popup.style.setProperty('--rpb-popup-top', `${Math.round(top)}px`);
      }

      function queuePosition() {
        if (!popup.hidden && frame === null) frame = requestAnimationFrame(position);
      }

      function stopTimer() {
        if (timer !== null) clearTimeout(timer);
        timer = null;
      }

      function close(restoreFocus = true) {
        pending = false;
        stopTimer();
        const hadFocus = popup.contains(document.activeElement);
        popup.hidden = true;
        if (!restoreFocus || !hadFocus) return;
        const target = focusBeforeOpening?.isConnected && focusBeforeOpening !== document.body
          ? focusBeforeOpening : document.querySelector('#MainContent');
        if (!target || typeof target.focus !== 'function') return;
        const hadTabIndex = target.hasAttribute('tabindex');
        if (!hadTabIndex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (!hadTabIndex) target.removeAttribute('tabindex');
      }

      function attemptShow() {
        timer = null;
        if (!pending || paused || !popup.isConnected) return;
        if (document.visibilityState === 'hidden') return; // A background tab is not an impression.
        const day = today();
        const preference = readPreference();
        if (!editor && preference?.daily && preference.lastDay === day) {
          pending = false;
          return;
        }
        if (overlayIsOpen()) {
          timer = setTimeout(attemptShow, 500);
          return;
        }
        pending = false;
        focusBeforeOpening = document.activeElement;
        popup.hidden = false;
        position();
        // The daily mode persists: it never falls back to every visit on a new day.
        if (!editor && preference?.daily) rememberDaily(day);
      }

      function beginVisit() {
        paused = false;
        close(false);
        pending = true;
        timer = setTimeout(attemptShow, editor ? 0 : 700);
      }

      popup.querySelector('[data-popup-close]').addEventListener('click', () => close(), options);
      popup.querySelector('[data-popup-daily]').addEventListener('click', () => {
        if (!editor) rememberDaily(today());
        close();
      }, options);
      popup.querySelector('[data-popup-link]').addEventListener('click', () => close(false), options);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !popup.hidden && !overlayIsOpen()) close();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible' && pending && !paused && timer === null) attemptShow();
      }, options);
      window.addEventListener('pagehide', () => { paused = true; close(false); }, options);
      window.addEventListener('pageshow', (event) => {
        // On an ordinary load init already started the visit. Only a restored page needs restarting.
        if (event.persisted) beginVisit();
      }, options);
      window.addEventListener('storage', (event) => {
        if (!editor && (event.key === STORAGE_KEY || event.key === null)) {
          const preference = readPreference();
          if (preference?.daily && preference.lastDay === today()) close();
        }
      }, options);
      window.addEventListener('resize', queuePosition, options);
      window.addEventListener('scroll', queuePosition, { ...options, passive: true });
      window.visualViewport?.addEventListener('resize', queuePosition, options);
      document.addEventListener('shopify:section:select', (event) => {
        if (editor && event.detail?.sectionId === id) beginVisit();
      }, options);
      controllers.set(id, () => {
        close(false);
        if (frame !== null) cancelAnimationFrame(frame);
        subscriptions.abort();
        popup.remove();
        controllers.delete(id);
      });
      beginVisit();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => controllers.get(event.detail?.sectionId)?.());
})();

  } catch(e) { console.error(e); }
})();
})();
